// extracted by mini-css-extract-plugin
export default {"button":"DisasterAddButton_button__QyigD","icon":"DisasterAddButton_icon__dfICK","badge":"DisasterAddButton_badge__PBy5s","bump":"DisasterAddButton_bump__Lqt1e"};